import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import SliderItemForm from './SliderItemForm';

import SlidersApi from 'Api/CRM/Modules/SlidersApi';
import SliderItem from 'Api/Models/SliderItem';
import SweetAlert from 'crm/elements/alerts/SweetAlert';
import Card from 'crm/elements/common/Card';
import handleValidationErrors, { ValidationErrors } from 'crm/helpers/ResponseErrorHelper';
import useNumberParams from 'crm/hooks/useNumberParams';

function SliderItemCreate() {
    const { id } = useNumberParams();
    const history = useHistory();
    const [errors, setErrors] = useState<ValidationErrors>({});

    const handleCreateSliderItem = async (newSliderItem: SliderItem) => {
        const data = new FormData();
        data.append('slider_id', String(id));
        data.append('language_id', String(newSliderItem.language_id));
        data.append('redirection_url', newSliderItem.redirection_url ?? '');
        data.append('alt_value', newSliderItem.alt_value ?? '');
        data.append('image_url', newSliderItem.image_url);
        data.append('lottery_id', newSliderItem.lottery_id ? String(newSliderItem.lottery_id) : '');

        if (newSliderItem.mobile_image_url) {
            data.append('mobile_image_url', newSliderItem.mobile_image_url);
        }

        try {
            await SweetAlert.loader(SlidersApi.storeItem(data));
            await SweetAlert.success('Slider item created correctly');
            history.push(`/slider/${id}`);
        } catch (error) {
            handleValidationErrors(error, setErrors);
        }
    };

    return (
        <Card title="Create new slider item">
            <SliderItemForm action={handleCreateSliderItem} errors={errors} />
        </Card>
    );
}

export default SliderItemCreate;
